module.exports = __webpack_public_path__ + "media/entities/5202-a7935040.png";